<div class="tm-wrap">

  <div class="tm-header">
    <h2 class="page-title">🧪 Test The Model</h2>
    <p class="page-sub">
      Upload a photo of a <strong>Cat 🐱</strong> or <strong>Dog 🐶</strong>
      and let the model decide!
    </p>
  </div>

  <div class="tm-layout">

        <!-- ╔═══ RESULT PANEL ═══╗ -->
    <div class="result-panel">
      <h4 style="color:var(--blue);">CNN Prediction</h4>
      <!-- Idle state -->
      <div class="result-idle" *ngIf="!cnnprediction && !cnnisLoading && !cnnerrorMsg">
        <span class="idle-icon">🤔</span>
        <p style="color:#ffffff;">Your prediction result will appear here after uploading an image.</p>
      </div>

      <!-- Loading state -->
      <div class="result-loading" *ngIf="cnnisLoading">
        <div class="spinner"></div>
        <p>Crunching pixels…</p>
      </div>

      <!-- Success state -->
      <div class="result-box"
           *ngIf="cnnprediction && !cnnisLoading"
           [style.background]="resultGradientcnn">

        <div class="result-animal">{{ resultEmojicnn }}</div>
        <h3 class="result-label">It's a <strong>{{ cnnprediction | titlecase }}</strong>!</h3>

        <div class="confidence-bar" *ngIf="cnnconfidence !== null">
          <div class="conf-label">
            Confidence: <strong>{{ cnnconfidence}}%</strong>
          </div>
          <div class="conf-track">
            <div class="conf-fill"
                 [style.width.%]="cnnconfidence"
                 [style.background]="cnnprediction.toLowerCase() === 'cat'
                   ? 'linear-gradient(90deg, #ff6b9d, #ff9dc6)'
                   : 'linear-gradient(90deg, #ffb347, #ffd080)'">
            </div>
          </div>
        </div>

        <button class="try-again-btn" (click)="clearImage()">
          🔄 Try Another
        </button>

      </div>

      <!-- Error state -->
      <div class="result-error" *ngIf="cnnerrorMsg && !cnnisLoading">
        <span>⚠️</span>
        <p>{{ cnnerrorMsg }}</p>
        <button class="try-again-btn err-retry" (click)="submitImage()">
          ↺ Retry
        </button>
      </div>

    </div>
    <!-- ╚═══════════════════╝ -->

    <!-- ╔═══ UPLOAD PANEL ═══╗ -->
    <div class="upload-panel">

      <!-- Dropzone -->
      <div class="dropzone"
           [class.dragging]="isDragging"
           [class.has-image]="!!previewUrl"
           (dragover)="onDragOver($event)"
           (dragleave)="onDragLeave()"
           (drop)="onDrop($event)"
           (click)="fileInput.click()">

        <!-- Placeholder -->
        <div class="drop-placeholder" *ngIf="!previewUrl">
          <span class="drop-emoji">📂</span>
          <p class="drop-main">Drag & Drop or <u>Browse</u></p>
          <p class="drop-hint">JPG · PNG · WEBP supported</p>
        </div>

        <!-- Preview -->
        <div class="preview-wrap" *ngIf="previewUrl">
          <img [src]="previewUrl" alt="Preview" class="preview-img" />
          <button class="clear-btn" (click)="clearImage(); $event.stopPropagation()">
            ✕
          </button>
        </div>

      </div>

      <input #fileInput type="file" accept="image/*"
             (change)="onFileSelected($event)" hidden />

      <!-- Submit -->
      <button class="predict-btn"
              (click)="submitImage()"
              [disabled]="!selectedFile || cnnisLoading || conkanisLoading">
        <span *ngIf="!cnnisLoading && !conkanisLoading">🔍 Run Prediction</span>
        <span *ngIf="cnnisLoading || conkanisLoading"  class="pulse-text">⏳ Analysing image…</span>
      </button>

    </div>
    <!-- ╚═══════════════════╝ -->

    <!-- ╔═══ RESULT PANEL ═══╗ -->
    <div class="result-panel">

      <h4 style="color:var(--blue);">Con-Kan Prediction</h4>
      <!-- Idle state -->
      <div class="result-idle" *ngIf="!conkanprediction && !conkanisLoading && !conkanerrorMsg">
        <span class="idle-icon">🤔</span>
        <p style="color:#ffffff;">Your prediction result will appear here after uploading an image.</p>
      </div>

      <!-- Loading state -->
      <div class="result-loading" *ngIf="conkanisLoading">
        <div class="spinner"></div>
        <p>Crunching pixels…</p>
      </div>

      <!-- Success state -->
      <div class="result-box"
           *ngIf="conkanprediction && !conkanisLoading"
           [style.background]="resultGradientconkan">

        <div class="result-animal">{{ resultEmojiconkan }}</div>
        <h3 class="result-label">It's a <strong>{{ conkanprediction | titlecase }}</strong>!</h3>

        <div class="confidence-bar" *ngIf="conkanconfidence !== null">
          <div class="conf-label">
            Confidence: <strong>{{ conkanconfidence }}%</strong>
          </div>
          <div class="conf-track">
            <div class="conf-fill"
                 [style.width.%]="conkanconfidence"
                 [style.background]="conkanprediction.toLowerCase() === 'cat'
                   ? 'linear-gradient(90deg, #ff6b9d, #ff9dc6)'
                   : 'linear-gradient(90deg, #ffb347, #ffd080)'">
            </div>
          </div>
        </div>

        <button class="try-again-btn" (click)="clearImage()">
          🔄 Try Another
        </button>

      </div>

      <!-- Error state -->
      <div class="result-error" *ngIf="conkanerrorMsg && !conkanisLoading">
        <span>⚠️</span>
        <p>{{ conkanerrorMsg }}</p>
        <button class="try-again-btn err-retry" (click)="submitImage()">
          ↺ Retry
        </button>
      </div>

    </div>
    <!-- ╚═══════════════════╝ -->

  </div>
</div>